import React, { FC } from 'react';
import classNames from 'classnames';
import { SystemButtonHyperlinkProps } from '../button.types';
import { Hyperlink } from '../../Hyperlink';
import { SystemHyperlinkDefault } from '../systemButtonDefaultProps';
import { SystemButtonContent } from '../SystemButton';
import styles from './custom.module.scss';

type Props = {
  iconLeft?: string;
  iconRight?: string;
  className?: string;
} & SystemButtonHyperlinkProps;

export const CustomHyperlink: FC<Props> = ({
  children,
  target,
  href,
  rel,
  source,
  iconLeft,
  iconRight,
  onClick,
  className = '',
}) => {
  return (
    <Hyperlink
      className={classNames(styles.custom, className)}
      target={target}
      href={href}
      rel={rel}
      source={source}
      onClick={onClick}
    >
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        {children}
      </SystemButtonContent>
    </Hyperlink>
  );
};

CustomHyperlink.defaultProps = SystemHyperlinkDefault;
